// Token Law — Aug 2026 UI refresh. One species, one color, one mark, everywhere.
// Docs: docs/plans/2026-08-ui-refresh/01-foundation-tokens-species.md
//
// Every post on Portal is one of three species; each owns exactly one color
// and one mark (SpeciesMark). Money verbs are a SEPARATE system and are never
// overridden by species color.

export const SPECIES = {
  signal: '#03FFFF',        // the beacon — "I'm here tonight" — ephemeral
  partyStarter: '#FF00FF',  // the floor — crowdfunding — pledges climb past a threshold
  guaranteed: '#000000',    // the check — "yes, this is happening"
};

export const MONEY = {
  join: '#03FF00',   // guaranteed / free — the JOIN verb
  pledge: '#FE0100', // party starter — the PLEDGE verb
};

// Map an Event to its species. Signals (public or portal) → signal; party_starter
// funding → partyStarter; everything else guaranteed.
export function speciesForEvent(event) {
  if (!event) return 'guaranteed';
  if (event.isPortalSignal || event.signalScope || event.signalText) return 'signal';
  if (event.fundingType === 'party_starter') return 'partyStarter';
  return 'guaranteed';
}

export function speciesColor(species) {
  return SPECIES[species] || SPECIES.guaranteed;
}
